import { Separator } from "../../../components/ui/common";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { formatCurrencyForTable } from "../../../lib/utils";
import { Vehicle } from "../../vehicle/@types";

interface VehicleTripCardProps {
  vehicle: Vehicle;
}

const VehicleTripCard02: React.FC<VehicleTripCardProps> = ({ vehicle }) => {
  const cards = [
    {
      label: "Total trip",
      value: formatCurrencyForTable(vehicle.totalTrips),
      index: 0,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          className="h-8 w-8 text-primary"
        >
          <path
            fill="currentColor"
            d="M25.91 14.47h-3.05V16h-1.52v3.05h1.52v1.52h3.05v-1.52h1.52V16h-1.52zm3.04 0h1.53V16h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Zm-6.09-1.52h6.09v1.52h-6.09Zm-1.53 1.52h1.53v1.52h-1.53Zm-1.52 1.52h1.52V16h-1.52ZM30.48 16H32v6.09h-1.52Zm-1.53 6.09h1.53v3.05h-1.53Zm-1.52 3.05h1.52v3.05h-1.52Zm-1.52 3.05h1.52v1.52h-1.52Zm-3.05 1.52h3.05v1.53h-3.05Zm-1.52-1.52h1.52v1.52h-1.52Zm-1.53-3.05h1.53v3.05h-1.53Zm-1.52-3.05h1.52v3.05h-1.52Zm-1.53 7.62h3.05v1.53h-3.05Zm0-13.71h1.53v6.09h-1.53ZM13.72 5.33h1.52v6.1h-1.52Zm-1.53 24.38h3.05v1.53h-3.05Zm0-18.28h1.53v3.04h-1.53Zm0-7.62h1.53v1.52h-1.53Zm-1.52 10.66h1.52v3.05h-1.52Zm0-12.19h1.52v1.53h-1.52ZM9.14 17.52h1.53v1.53H9.14ZM7.62 29.71h3.05v1.53H7.62Zm1.52-25.9H6.1v1.52H4.57v3.05H6.1V9.9h3.04V8.38h1.53V5.33H9.14zM6.1 26.67h1.52v3.04H6.1Zm0-4.58h1.52v3.05H6.1Zm0-3.04h3.04v1.52H6.1ZM4.57.76h6.1v1.52h-6.1Zm0 16.76H6.1v1.53H4.57Zm-1.52-3.05h1.52v3.05H3.05Zm0-12.19h1.52v1.53H3.05Zm-1.52 9.15h1.52v3.04H1.53Zm0-7.62h1.52v1.52H1.53ZM0 5.33h1.53v6.1H0Z"
          />
        </svg>
      ),
    },
    {
      label: "Total distance",
      value: `${formatCurrencyForTable(vehicle.totalDistance)} km`,
      index: 1,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          className="h-8 w-8 text-primary"
        >
          <path
            fill="currentColor"
            d="M25.91 14.47h-3.05V16h-1.52v3.05h1.52v1.52h3.05v-1.52h1.52V16h-1.52zm3.04 0h1.53V16h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Zm-6.09-1.52h6.09v1.52h-6.09Zm-1.53 1.52h1.53v1.52h-1.53Zm-1.52 1.52h1.52V16h-1.52ZM30.48 16H32v6.09h-1.52Zm-1.53 6.09h1.53v3.05h-1.53Zm-1.52 3.05h1.52v3.05h-1.52Zm-1.52 3.05h1.52v1.52h-1.52Zm-3.05 1.52h3.05v1.53h-3.05Zm-1.52-1.52h1.52v1.52h-1.52Zm-1.53-3.05h1.53v3.05h-1.53Zm-1.52-3.05h1.52v3.05h-1.52Zm-1.53 7.62h3.05v1.53h-3.05Zm0-13.71h1.53v6.09h-1.53ZM13.72 5.33h1.52v6.1h-1.52Zm-1.53 24.38h3.05v1.53h-3.05Zm0-18.28h1.53v3.04h-1.53Zm0-7.62h1.53v1.52h-1.53Zm-1.52 10.66h1.52v3.05h-1.52Zm0-12.19h1.52v1.53h-1.52ZM9.14 17.52h1.53v1.53H9.14ZM7.62 29.71h3.05v1.53H7.62Zm1.52-25.9H6.1v1.52H4.57v3.05H6.1V9.9h3.04V8.38h1.53V5.33H9.14zM6.1 26.67h1.52v3.04H6.1Zm0-4.58h1.52v3.05H6.1Zm0-3.04h3.04v1.52H6.1ZM4.57.76h6.1v1.52h-6.1Zm0 16.76H6.1v1.53H4.57Zm-1.52-3.05h1.52v3.05H3.05Zm0-12.19h1.52v1.53H3.05Zm-1.52 9.15h1.52v3.04H1.53Zm0-7.62h1.52v1.52H1.53ZM0 5.33h1.53v6.1H0Z"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {cards.map(({ label, value, index, icon }) => (
        <>
          <DashboardCard
            key={index}
            icon={icon}
            value={value}
            label={label}
            className="w-[300px]"
          />

          {index < cards?.length - 1 && <Separator />}
        </>
      ))}
    </div>
  );
};

export default VehicleTripCard02;
